/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmemberremoveconfirm3Inputs */

const en_groupsmemberremoveconfirm3 = /** @type {(inputs: Groupsmemberremoveconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Really remove`)
};

const de_groupsmemberremoveconfirm3 = /** @type {(inputs: Groupsmemberremoveconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirklich entfernen`)
};

/**
* | output |
* | --- |
* | "Really remove" |
*
* @param {Groupsmemberremoveconfirm3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmemberremoveconfirm3 = /** @type {((inputs?: Groupsmemberremoveconfirm3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmemberremoveconfirm3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmemberremoveconfirm3(inputs)
	return de_groupsmemberremoveconfirm3(inputs)
});
export { groupsmemberremoveconfirm3 as "groupsMemberRemoveConfirm" }